var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-data"},[_c('span',{staticClass:"not-data-text"},[_vm._v(_vm._s(_vm.$t("el.common.noData")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }